export default __webpack_public_path__ + "b3971920576ecdd4ef648ccba0ad38b1.png";